import React from 'react';
import {
  donViSearchColumns,
  loSearchColumns,
  QUERY_KEYS,
  vatTuSearchColumns,
  viTriSearchColumns,
  warehouseSearchColumns
} from '@/constants';
import { type DonViCoSo, KhoHang, Lo, VatTu, ViTri, type ViTriKho } from '@/types/schemas';
import { SearchFieldV2 as SearchField, FormFieldV2 as FormField } from '@/components/custom/erp';
import { SearchFieldActions, SearchFieldState } from '../../hooks';
import { Label } from '@/components/ui/label';

interface DetailTabProps {
  searchFieldState: SearchFieldState;
  searchFieldActions: SearchFieldActions;
}

const DetailTab = ({ searchFieldState, searchFieldActions }: DetailTabProps) => {
  return (
    <div className='p-4'>
      {/* Mã vật tư */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã vật tư</Label>
        <SearchField<VatTu>
          searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
          searchColumns={vatTuSearchColumns}
          columnDisplay='ma_vt'
          displayRelatedField='ten_vt'
          dialogTitle='Danh mục vật tư'
          relatedFieldValue={searchFieldState.vatTu?.ma_vt}
          value={searchFieldState.vatTu?.ma_vt}
          onRowSelection={searchFieldActions.setVatTu}
          className='w-100'
        />
      </div>

      {/* Mã kho */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã kho</Label>
        <SearchField<KhoHang>
          searchEndpoint={`/${QUERY_KEYS.KHO_HANG}/`}
          searchColumns={warehouseSearchColumns}
          columnDisplay='ma_kho'
          displayRelatedField='ten_kho'
          dialogTitle='Danh mục kho hàng'
          relatedFieldValue={searchFieldState.khoHang?.ma_kho}
          onRowSelection={searchFieldActions.setKhoHang}
          className='w-100'
        />
      </div>

      {/* Mã lô */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã Lô</Label>
        <SearchField<Lo>
          searchEndpoint={`/${QUERY_KEYS.LO}/`}
          searchColumns={loSearchColumns}
          columnDisplay='ma_lo'
          displayRelatedField='ten_lo'
          dialogTitle='Danh mục lô'
          value={searchFieldState.lo?.ma_lo}
          relatedFieldValue={searchFieldState.lo?.ma_lo}
          onRowSelection={searchFieldActions.setLo}
          className='w-100'
        />
      </div>

      {/* Mã vị trí */}
      <div className='mb-4 flex items-center'>
        <Label className='w-[150px]'>Mã vị trí</Label>
        <SearchField<ViTriKho>
          searchEndpoint={`/${QUERY_KEYS.VI_TRI}/`}
          searchColumns={viTriSearchColumns}
          columnDisplay='ma_vi_tri'
          displayRelatedField='ten_vi_tri'
          dialogTitle='Danh mục vị trí kho hàng'
          value={searchFieldState.viTri?.ma_vi_tri}
          relatedFieldValue={searchFieldState.viTri?.ma_vi_tri}
          onRowSelection={searchFieldActions.setViTri}
          className='w-100'
        />
      </div>

      <div className='mt-3 border-t border-gray-200'></div>

      <div className='flex items-center'>
        <Label className='w-[150px]'>Đơn vị</Label>
        <SearchField<DonViCoSo>
          searchEndpoint={`/${QUERY_KEYS.DON_VI_CO_SO}/`}
          searchColumns={donViSearchColumns}
          columnDisplay='ma_unit'
          displayRelatedField='ten_unit'
          dialogTitle='Danh mục đơn vị'
          value={searchFieldState.donVi?.ma_unit}
          relatedFieldValue={searchFieldState.donVi?.ma_unit}
          onRowSelection={searchFieldActions.setDonVi}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-[150px]'>Trạng thái</Label>
        <FormField
          name='status'
          type='select'
          options={[
            { value: 'ALL', label: 'Tất cả' },
            { value: '0', label: 'Lập chứng từ' },
            { value: '3', label: 'Chờ duyệt' },
            { value: '5', label: 'Xuất hóa đơn' }
          ]}
        />
      </div>
    </div>
  );
};

export default DetailTab;
